import { connect } from 'react-redux'
import UserSelectorComp from '../../components/layout/userSelector.component'
import { selectUser } from '../../actions'

const mapStateToProps = (state) => {
  const { adminUser } = state
  const { usersList } = adminUser

  const selectedIndex = adminUser.selectedUser.email
    ? usersList.findIndex((el) => el.email === adminUser.selectedUser.email)
    : -1

  const selectedEmail = adminUser.selectedUser.email

  return {
    state,
    usersList,
    selectedIndex: selectedIndex,
    selectedEmail: selectedEmail
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    selectUser: (data) => dispatch(selectUser(data))
  }
}

const UserSelectorContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(UserSelectorComp)

export default UserSelectorContainer
